import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { getData, putData } from "../API";
import { toast, ToastContainer } from "react-toastify";


function ReportEdit({ editableDetails,setEditShow,fetchData,handleSearch }) {
  const [formData, setFormData] = useState({
    sdid: editableDetails.sdid,
    ownerName: editableDetails.ownerName,
    ownerContactNumber: editableDetails.ownerContactNo,
    propertyHouseNumber: editableDetails.houseNo,
    wardNumber: editableDetails.wardNo,
    address: editableDetails.address,
    serviceStatusId: editableDetails.serviceStatusId || "",
    rateCategoryId:  editableDetails.rateCategoryId || "",
    rateCategoryName:  editableDetails.rateCategoryName || "",
    rateSubCategoryId: editableDetails.rateSubCategoryId || "",
    rateSubCategoryName: editableDetails.rateSubCategoryName || "",
    fixedValue: editableDetails.fixedValue || "",
    // serviceStatusName: editableDetails.serviceStatusName,
  });
  const [rateCategories, setRateCategories] = useState([]);
  const [rateSubCategories, setRateSubCategories] = useState([]);
  const [errors, setErrors] = useState({});
  const serviceStatusOptions = [
    { serviceStatusId: 1, serviceStatusName: "Service being received" },
    { serviceStatusId: 2, serviceStatusName: "Service not being received" },
  ];
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handleServiceStatusChange = (e) => {
    const selectedId = e.target.value ? parseInt(e.target.value, 10) : "";
    const selectedStatus = serviceStatusOptions.find(
      (status) => status.serviceStatusId === selectedId
    );
  
    setFormData((prevData) => ({
      ...prevData,
      serviceStatusId: selectedId,
      // serviceStatusName: selectedStatus ? selectedStatus.serviceStatusName : "",
    }));
  };
  const handleSave = async () => {
    const newErrors = {};
    if (!formData.serviceStatusId) {
      newErrors.serviceStatusId = "Service Status is required";
    }
  
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return; // Stop submission if validation fails
    }
  
    setErrors({});
    try {
      const res = await putData("SurveyDetails/v2/UpdateSurveyourSubDetails", formData); // Log the entire response object
      switch (res.statusCode) {
        case 401: // Unauthorized
        toast.error("You don't have permission to edit this record", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        return;
        case 409:
          toast.error(res.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          return; 
        case 400:
            toast.error("One or more validation errors occurred." + res.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            return; 
        case 200: 
          toast.success("Data updated successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setEditShow(false); 
          fetchData(); 
          handleSearch();
          break;
        default: 
          toast.error("Unexpected response: " + res.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
      }
    } catch (error) {
      toast.error("An error occurred while updating data", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
      });
    }
  };
   useEffect(() => {
      const fetchRateCategories = async () => {
        try {
          const res = await getData("RateCategory/GetCategories");
          const activeCategories = res?.items?.filter((item) => item.isActive) || [];
          setRateCategories(activeCategories);
        } catch (error) {
          toast.error("Failed to load rate categories", { autoClose: 5000 });
        }
      };
      fetchRateCategories();
    }, []);
    useEffect(() => {
      const fetchRateSubCategories = async () => {
        if (formData.rateCategoryId) {
          try {
            const res = await getData("RateSubCategory/GetSubCategories");
            const filtered = res?.items?.filter((item) => item.isActive) || [];
            setRateSubCategories(filtered);
          } catch (error) {
            toast.error("Failed to load rate subcategories", { autoClose: 5000 });
          }
        } else {
          setRateSubCategories([]);
        }
      };
    
      fetchRateSubCategories();
    }, [formData.rateCategoryId]);
    
  return (
    <>
      <Form>
        <ToastContainer />
        <div className="row filters ps-4 pt-3 pb-3 pe-4">
          <div className="col-md-6">
            <Form.Group controlId="ownerName" className="mb-3">
              <Form.Label>Owner Name</Form.Label>
              <Form.Control
                style={{
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
                type="text"
                placeholder="Enter Owner Name"
                value={formData.ownerName}
                onChange={handleInputChange}
              />
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group controlId="ownerContactNumber" className="mb-3">
              <Form.Label>Owner Contact Number</Form.Label>
              <Form.Control
                style={{
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
                type="text"
                value={formData.ownerContactNumber}
                onChange={handleInputChange}
                placeholder="Enter Owner Contact"
                maxLength={10}
              />
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group controlId="propertyHouseNumber" className="mb-3">
              <Form.Label>Property House Number</Form.Label>
              <Form.Control
                style={{
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
                value={formData.propertyHouseNumber}
                placeholder="Enter Property House"
                onChange={handleInputChange}
                type="text"
              />
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group controlId="wardNumber" className="mb-3">
              <Form.Label>Ward Number</Form.Label>
              <Form.Control
                style={{
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
                value={formData.wardNumber}
                placeholder="Enter Ward Number"
                onChange={handleInputChange}
                type="text"
              />
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group controlId="address" className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                style={{
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
                value={formData.address}
                placeholder="Enter Address"
                onChange={handleInputChange}
                type="text"
              />
            </Form.Group>
          </div>
          <div className="col-md-6">
          <Form.Group controlId="rateCategoryId" className="mb-3">
            <Form.Label>
              Category
            </Form.Label>
            <Form.Select
              style={{
                boxShadow:
                  "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                borderColor: errors.rateCategoryId ? "red" : "",
              }}
              value={formData.rateCategoryId}
              onChange={(e) => {
                const selectedId = parseInt(e.target.value);
                const selected = rateCategories.find((item) => item.rtId === selectedId);
                setFormData({
                  ...formData,
                  rateCategoryId: selectedId,
                  rateCategoryName: selected?.categoryName || "",
                  rateSubCategoryId: "",
                  rateSubCategoryName: "",
                });
                setErrors({ ...errors, rateCategoryId: "" }); // clear error on change
              }}
              isInvalid={!!errors.rateCategoryId}
            >
              <option value="">Select Category</option>
              {rateCategories.map((cat) => (
                <option key={cat.rtId} value={cat.rtId}>
                  {cat.categoryName}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          </div>
          <div className="col-md-6">
          <Form.Group controlId="rateSubCategoryId" className="mb-3">
            <Form.Label>
              Sub Category
            </Form.Label>
            <Form.Select
              style={{
                boxShadow:
                  "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                borderColor: errors.rateSubCategoryId ? "red" : "",
              }}
              value={formData.rateSubCategoryId}
              onChange={(e) => {
                const selectedId = parseInt(e.target.value);
                const selected = rateSubCategories.find(
                  (item) => item.rsctId === selectedId
                );
                setFormData({
                  ...formData,
                  rateSubCategoryId: selectedId,
                  rateSubCategoryName: selected?.subCategoryName || "",
                });
                setErrors({ ...errors, rateSubCategoryId: "" }); // clear error on change
              }}
              isInvalid={!!errors.rateSubCategoryId}
              disabled={!formData.rateCategoryId}
            >
              <option value="">Select Sub Category</option>
              {rateSubCategories.map((sub) => (
                <option key={sub.rsctId} value={sub.rsctId}>
                  {sub.subCategoryName}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </div>
        <div className="col-md-6">
        <Form.Group controlId="fixedValue" className="mb-3">
          <Form.Label>
            Rate
          </Form.Label>
          <Form.Control
            type="text"
            name="fixedValue"
            value={formData.fixedValue}
            onChange={(e) => {
              setFormData({ ...formData, fixedValue: e.target.value });
              setErrors({ ...errors, fixedValue: "" }); // clear error on change
            }}
            placeholder="Enter Rate"
            style={{
              boxShadow:
                "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
              borderColor: errors.fixedValue ? "red" : "",
            }}
            isInvalid={!!errors.fixedValue}
          />
          {errors.fixedValue && (
            <div className="text-danger mt-1">{errors.fixedValue}</div>
          )}
        </Form.Group>
      </div>


          <div className="col-md-6">
          <Form.Group controlId="serviceStatus" className="mb-3">
          <Form.Label>Service Status<span className="text-danger">*</span></Form.Label>
          <Form.Select
            style={{
              boxShadow:
                "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
              borderColor: errors.serviceStatusId ? "red" : "",
            }}
            value={formData.serviceStatusId}
            onChange={(e) => {
              handleServiceStatusChange(e);
              setErrors({ ...errors, serviceStatusId: "" }); // clear error on change
            }}
            isInvalid={!!errors.serviceStatusId}
          >
            <option value="">Select Service Status</option>
            {serviceStatusOptions.map((status) => (
              <option key={status.serviceStatusId} value={status.serviceStatusId}>
                {status.serviceStatusName}
              </option>
            ))}
          </Form.Select>
          {errors.serviceStatusId && (
            <div className="text-danger mt-1">{errors.serviceStatusId}</div>
          )}
        </Form.Group>

        </div>
        </div>
        

        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="primary"
            onClick={handleSave}
            style={{
              boxShadow:
                "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
            }}
          >
            SUBMIT
          </Button>
        </div>
      </Form>
    </>
  );
}

export default ReportEdit;
